'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FEW_MINUTES = exports.FEW_MINUTES = 'FEW_MINUTES';
var FEW_HOURS = exports.FEW_HOURS = 'FEW_HOURS';
var WITHIN_DAY = exports.WITHIN_DAY = 'WITHIN_DAY';